<template>
  <div>
    <el-autocomplete
        v-model="customerName"
        v-bind="$attrs"
        v-on="$listeners"
        :fetch-suggestions="querySearchAsync"
        style="width: 100%"
        placeholder="请输入客户名称"
        clearable
        @select="handleSelect"
        @clear="clearSelect"

    >
    </el-autocomplete>
  </div>
</template>

<script>
import {customerSearch} from "@/api/customers";

export default {
  name: "CustomerSearch",
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    },
    size: {
      type: String,
      default() {
        return 'mini'
      }
    }
  },
  data() {
    return {
      customerName: this.name
    }
  },
  watch: {
    name: function (newVal, oldVal) {
      if (newVal !== oldVal)
        this.customerName = newVal
    },
    customerName: function (newVal, oldVal) {
      if (newVal !== oldVal)
        this.$emit('update:name', newVal)
    }
  },
  methods: {
    async querySearchAsync(queryString, cb) {
      if (this.customerName) {
        const list = await customerSearch({search: this.customerName}).then((res) => {
          return res.model.data
        })
        cb(list)
      } else {
        cb([])
      }
    },
    // 处理搜索结果的选中
    handleSelect(item) {
      this.$emit('handleSelect', item)
    },
    clearSelect: function () {
      this.$emit('handleSelect', {})
    }
  }
}
</script>

<style scoped>

</style>